import { Visibility } from "../Visibility";
import Styles from "./Spacer.module.scss";

interface Props {
  orientation?: "horizontal" | "vertical";
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl" | "flex";
}

const SpacerComponent = ({ size = "md", orientation = "horizontal" }: Props) => (
  <div className={[Styles.spacer, Styles[size], Styles[orientation]].join(" ")} />
);

interface MobileSpacerProps {
  xl?: boolean;
  lg?: boolean;
  md?: boolean;
  sm?: boolean;
  xs?: boolean;
}

export const Spacer = {
  Vertical: (props: Omit<Props, "orientation">) => SpacerComponent({ ...props, orientation: "vertical" }),
  Horizontal: (props: Omit<Props, "orientation">) => SpacerComponent({ ...props, orientation: "horizontal" }),
  Mobile: (props: MobileSpacerProps) => (
    <Visibility.Show {...props}>
      <SpacerComponent orientation="vertical" size={"md"} />
    </Visibility.Show>
  ),
};
